// #ux-redesign-start: AuthCard (Paso 5 — Auth redesign)
// Card del formulario de auth. Estructura compartida por Login / Register /
// Password Recovery:
//   - Header: logo + title + descripción opcional
//   - Body: children (el form)
//   - Footer-links: slot opcional para navegación inferior (Register, Forgot, Back)
//
// PORTABILIDAD: trasplantable a Web-Patients.
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_LOGO = '/General/login/logo.svg';

const AuthCard = ({
  title,
  description,
  logo = DEFAULT_LOGO,
  hideLogo = false,
  children,
  footerLinks,
}) => (
  <div className="ds-auth__card">
    {!hideLogo && (
      <div className="ds-auth__card-logo">
        <img src={logo} alt="TelePraxen" />
      </div>
    )}
    {title && <h1 className="ds-auth__card-title">{title}</h1>}
    {description && (
      <p className="ds-auth__card-description">{description}</p>
    )}
    <div className="ds-auth__card-body">{children}</div>
    {footerLinks && (
      <nav className="ds-auth__card-links">{footerLinks}</nav>
    )}
  </div>
);

AuthCard.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
  logo: PropTypes.string,
  hideLogo: PropTypes.bool,
  children: PropTypes.node.isRequired,
  footerLinks: PropTypes.node,
};

export default AuthCard;
// #ux-redesign-end
